type ImportStepperProps = {
  steps: string[]
  current: number
  label?: string
}

export const ImportStepper = ({ steps, current, label = 'Шаги импорта' }: ImportStepperProps) => (
  <nav aria-label={label}>
    <ol className="market-stepper">
      {steps.map((label, index) => {
        const state = index < current ? 'done' : index === current ? 'current' : 'todo'
        return (
          <li
            key={label}
            className={`market-stepper__item market-stepper__item--${state}`}
            aria-current={state === 'current' ? 'step' : undefined}
          >
            <span className="market-stepper__num" aria-hidden="true">
              {state === 'done' ? '✓' : index + 1}
            </span>
            <span className="market-stepper__label">{label}</span>
            {state === 'done' ? <span className="visually-hidden"> (выполнен)</span> : null}
          </li>
        )
      })}
    </ol>
  </nav>
)
